import { render, staticRenderFns } from "./OrganisationsTable.vue?vue&type=template&id=15f87806&scoped=true&"
import script from "./OrganisationsTable.vue?vue&type=script&lang=js&"
export * from "./OrganisationsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationsTable.vue?vue&type=style&index=0&id=15f87806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f87806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
